
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext"; // Import LanguageProvider
import AppWrapper from "./AppWrapper";
import "./index.css";
import { SessionProvider } from './context/SessionContext';


function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <LanguageProvider>
      <SessionProvider>
        <AppWrapper />
        </SessionProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;